import axiosSetup from "../utils/axiosSetup";

export interface GPMetrics {
  orderCount: number;
  orderNumbers: string[];
  orderValue: number;
  allocationCost: number;
  salesRepCommission: number;
  channelPartnerRepayment: number;
  channelPartnerCharges: number;
  gp: number;
}

export interface GPHierarchyNode {
  _id: string;
  username: string;
  role: string;
  managerId: string | null;
  own: GPMetrics;
  team: GPMetrics;
  orderCount: number;
  orderNumbers: string[];
  orderValue: number;
  allocationCost: number;
  salesRepCommission: number;
  channelPartnerRepayment: number;
  channelPartnerCharges: number;
  gp: number;
  children: GPHierarchyNode[];
}

export interface GPBasedOnOrdersResponse {
  data: {
    hierarchy: GPHierarchyNode[];
    filters: {
      fromDate: string;
      toDate: string;
      skipRoles: string[];
    };
  };
}

export const fetchGPBasedOnOrdersApi = async ({
  fromDate,
  toDate,
  selectedUserIds,
  deselectedUserIds,
}: {
  fromDate: string;
  toDate: string;
  selectedUserIds?: string[];
  deselectedUserIds?: string[];
}): Promise<GPBasedOnOrdersResponse> => {
  const res = await axiosSetup.post(
    "/dashboard/get-gp",
    { selectedUserIds, deselectedUserIds },
    { params: { fromDate, toDate } },
  );
  return res.data;
};
